<template>
    <canvas :id="`grafica-${dia}`"></canvas>
</template>

<script>
import Chart from 'chart.js'

export default {
    name: 'GraficaDia',
    props: {
        dia: { type: String, required: true },
        intervalos: { type: Array, required: true }, // ej: ['08:00', '08:30', ...]
        asignados: { type: Array, required: true }, // barras por intervalo
        programados: { type: Array, required: true }, // línea roja
        requeridos: { type: Array, required: true }, // línea amarilla
        maxY: { type: Number, default: null }
    },
    data() {
        return {
            chart: null
        }
    },
    mounted() {
        const ctx = document.getElementById(`grafica-${this.dia}`).getContext('2d')

        this.chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels: this.intervalos,
                datasets: [
                    {
                        type: 'bar',
                        label: 'Programados',
                        data: this.asignados,
                        backgroundColor: 'rgba(0, 123, 255, 0.6)',
                        borderColor: 'rgba(0, 123, 255, 1)',
                        borderWidth: 1
                    },
                    {
                        type: 'line',
                        label: 'Requeridos con reductores',
                        data: this.programados,
                        borderColor: 'red',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.1
                    },
                    {
                        type: 'line',
                        label: 'Requeridos sin reductores ',
                        data: this.requeridos,
                        borderColor: 'orange',
                        borderWidth: 2,
                        fill: false,
                        tension: 0.1
                    }
                ],
            },
            options: {
                responsive: true,
                plugins: {
                    legend: { position: 'top' },
                    title: {
                        display: true,
                        text: `Distribución de agentes - ${this.dia}`
                    },
                    datalabels: {
                        display: (ctx) => ctx.datasetIndex === 0,
                        anchor: 'end',
                        align: 'top',
                        offset: 5,
                        // --- ESTO EVITA QUE LA LÍNEA LO "TACHE" ---
                        color: '#000',
                        font: { weight: 'bold', size: 10 },
                        textStrokeColor: '#fff', // Borde blanco
                        textStrokeWidth: 4,      // Grosor del borde
                        // -----------------------------------------
                        rotation: -45,
                        formatter: (value) => {
                            // Esto muestra el valor tal cual viene en el array de datos
                            return value;
                        },
                        clip: false
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            max: this.maxY
                        },
                        scaleLabel: {
                            display: true,
                            labelString: 'Número de Agentes'
                        }
                    }],
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: 'Intervalos de media hora'
                        }
                    }]
                },
            }
        })
    },
    watch: {
        maxY(nuevo) {
            if (this.chart) {
                this.chart.options.scales.yAxes[0].ticks.max = nuevo
                this.chart.update()
            }
        },
        asignados: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[0].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        programados: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[1].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        requeridos: {
            handler(nuevo) {
                if (this.chart) {
                    this.chart.data.datasets[2].data = nuevo
                    this.chart.update()
                }
            },
            deep: true
        },
        intervalos(nuevo) {
            if (this.chart) {
                this.chart.data.labels = nuevo
                this.chart.update()
            }
        }
    }
}
</script>